// extracted by mini-css-extract-plugin
module.exports = {"i165vvr1":"i165vvr1","i6el1g6":"i6el1g6","shfe3ke":"shfe3ke","wcnkszl":"wcnkszl","p1lgzcrp":"p1lgzcrp"};